import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { updateInstrumentApi } from "../../../services/CalibrationService";
import { Modal } from "react-bootstrap";

const EditInstrument = ({ data, handleAfterUpdate }) => {
  const [dataInput, setDataInput] = useState({
    instrument_name: "",
    serial_number: "",
    description: "",
    photo: null,
  });
  const [errors, setErrors] = useState({});
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  // Open and close modal
  const openModal = () => setShowModal(true);
  const closeModal = () => {
    setDataInput({
      instrument_name: "",
      serial_number: "",
      description: "",
      photo: null,
    });
    setErrors({});
    setShowModal(false);
  };

  // Populate the form if data is passed as a prop
  useEffect(() => {
    if (data) {
      setDataInput({
        id: data.id || "",
        instrument_name: data.name || "",
        serial_number: data.serial_number || "",
        description: data.description || "",
        photo: data.photo || null,
      });
    }
  }, [data]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      setDataInput((prevDataInput) => ({
        ...prevDataInput,
        [name]: files[0],
      }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
      setDataInput((prevDataInput) => ({ ...prevDataInput, [name]: value }));
    }
  };

  // Validate form inputs
  const validateForm = () => {
    const newErrors = {};
    if (!dataInput.instrument_name) newErrors.instrument_name = "Instrument name is required.";
    if (!dataInput.serial_number) newErrors.serial_number = "Serial number is required.";
    if (!dataInput.description) newErrors.description = "Description is required.";
    if (!dataInput.photo) newErrors.photo = "Photo is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Submit the form
  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
      setIsSubmitLoading(true);
      const formData = new FormData();
      formData.append("id", dataInput.id);
      formData.append("instrument_name", dataInput.instrument_name);
      formData.append("serial_number", dataInput.serial_number);
      formData.append("description", dataInput.description);
      formData.append("photo", dataInput.photo);

      const response = await updateInstrumentApi(formData);
      handleAfterUpdate(response.data.results);
      toast.success(response.data.message);
      navigate("/calibration");
      closeModal();
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred.");
    } finally {
      setIsSubmitLoading(false);
    }
  };

  return (
    <>
      <span className="text-primary fw-bold me-3 c-pointer" onClick={openModal}>
        {data?.name}
      </span>
      <Modal show={showModal} onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Instrument</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mb-2">
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label">
                  Instrument Name<span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  placeholder="Enter Instrument Name"
                  name="instrument_name"
                  value={dataInput.instrument_name}
                  onChange={handleChange}
                />
                {errors.instrument_name && (
                  <div className="text-danger">{errors.instrument_name}</div>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label">
                  Serial Number<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="serial_number"
                  value={dataInput.serial_number}
                  onChange={handleChange}
                />
                {errors.serial_number && (
                  <div className="text-danger">{errors.serial_number}</div>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label">
                  Description<span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  name="description"
                  value={dataInput.description}
                  onChange={handleChange}
                ></textarea>
                {errors.description && (
                  <div className="text-danger">{errors.description}</div>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label">
                  Photo<span className="text-danger">*</span>
                </label>
                <input
                  type="file"
                  className="form-control"
                  name="photo"
                  onChange={handleChange}
                />
                {errors.photo && <div className="text-danger">{errors.photo}</div>}
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-start">
            <button
              type="button"
              className="btn btn-primary me-3"
              onClick={handleSubmit}
              disabled={isSubmitLoading}
            >
              {isSubmitLoading ? "Updating..." : "Update"}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EditInstrument;
